import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActionCreator } from "actions";
import { CommonModalHeader } from "component/common";
import * as queryString from "query-string";
import "containers/GameRoundResult/styles.scss";
import { withNamespaces } from "react-i18next";

class GameRoundResult extends Component {
  constructor(props) {
    super(props);
    this.onClickPrevious = this._onClickPrevious.bind(this);
    this.onCloseClickHandler = this._onCloseClickHandler.bind(this);
  }

  _onClickPrevious() {
    this.props.history.goBack();
  }

  _onCloseClickHandler() {
    this.props.navigateTo(this.props.location.pathname);
  }

  render() {
    const { t } = this.props;
    if (this.props.modalRel !== "game-round-result") {
      return null;
    }

    return (
      <div className="game-round-result">
        <CommonModalHeader
          onClickPrevious={this.onClickPrevious}
          onCloseClickHandler={this.onCloseClickHandler}
        />
        <div className="title row" ref={this.titleRef}>
          <div className="col">
            <span>{t("result")}</span>
          </div>
        </div>

        <iframe title="Game Round Result" src={this.props.gameResultUrl} />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  let { modalRel, gameResultUrl } = queryString.parse(ownProps.location.search);

  if (!modalRel || (modalRel && modalRel.indexOf("game-round-result") < 0)) {
    return {};
  }

  return {
    modalRel,
    gameResultUrl: atob(gameResultUrl),
    navigateTo: (path) => ownProps.history.push(path),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return bindActionCreators(ActionCreator, dispatch);
};

const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, ownProps, {});
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(withNamespaces("translation")(GameRoundResult));
